import {createStore} from 'vuex';

const store = createStore({
    state: {
        isMobile: false
    },
    getters: {
        isMobile(state) {
            return state.isMobile
        }
    },
    mutations: {
        setIsMobile(state, isMobile) {
            state.isMobile = isMobile
        }
    },
    actions: {
        setIsMobile(context, isMobile) {
            context.commit('setIsMobile', isMobile)
        }
    }
})

export default store
